<template>
    <div class="timeKeeping-box">
        <HeaderNav
            header-title="考勤打卡"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="clock-con">
            <div class="header">
                <span class="head-icon">明</span>
                <div class="name">
                    <h4>周小明</h4>
                    <div>罐车-司机</div>
                </div>
                <div class="time">
                    <span>2020-02-29</span>
                    <span class="iconfont iconfanhui1"></span>
                </div>
            </div>
            <div class="body">
                <div class="tit-con">
                    <span class="left">月度考勤总数</span>
                    <div class="right" @click="toCalendar">
                        <span class="iconfont icondaqiayueli"></span>
                        <span>打卡月历</span>
                    </div>
                </div>
                <ul class="time-days">
                    <li>
                        <span>出勤天数</span>
                        <div class="days">
                            <span>21天</span>
                            <span class="iconfont iconfanhui1"></span>
                        </div>
                    </li>
                    <li>
                        <span>平均工时</span>
                        <div class="days">
                            <span>8小时</span>
                            <span class="iconfont iconfanhui1"></span>
                        </div>
                    </li>
                    <li>
                        <span>正常天数</span>
                        <div class="days">
                            <span>20天</span>
                            <span class="iconfont iconfanhui1"></span>
                        </div>
                    </li>
                    <li>
                        <span>休息天数</span>
                        <div class="days">
                            <span>9天</span>
                            <span class="iconfont iconfanhui1"></span>
                        </div>
                    </li>
                </ul>
                <div class="split"></div>
                <van-collapse v-model="activeNames" accordion>
                    <van-collapse-item title="迟到" :value="'3次'" name="1">
                        <ul class="times">
                            <li v-for="item in [1,2,3]" :key="item">
                                <div>
                                    <span class="color1">2020-02-01</span>
                                    <span class="weekday">星期一</span>
                                </div>
                                <span class="color1">1小时</span>
                            </li>
                        </ul>
                    </van-collapse-item>
                    <van-collapse-item title="早退" :value="'0次'" name="2"></van-collapse-item>
                    <van-collapse-item title="缺卡" :value="'0次'" name="3"></van-collapse-item>
                </van-collapse>
            </div>
            <div class="footer">
                <van-tabbar v-model="active" active-color="#FA4634" inactive-color="#979EA7">
                    <van-tabbar-item to="/carManage">
                        <span>打卡</span>
                        <template #icon="props">
                            <span :class="props.active ? 'iconfont icondaka active' : 'iconfont icondaka'"></span>
                        </template>
                    </van-tabbar-item>
                    <van-tabbar-item to="/timeKeeping">
                        <span>统计</span>
                        <template #icon="props">
                            <span :class="props.active ? 'iconfont icontongji1 active' : 'iconfont icontongji1'"></span>
                        </template>
                    </van-tabbar-item>
                </van-tabbar>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast } from 'vant';
export default {
    components: { HeaderNav },
    props: {},
    data() {
        return {
            active: 1, // 底部选项卡选中index
            activeNames: '1',
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 跳转到打卡月历
        toCalendar() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'calendar' });
        },
    },
    created() {},
    mounted() {},
};
</script>
<style lang="stylus">
.timeKeeping-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    display flex
    flex-direction column
    .dialog-con
        img
            width 100%
            margin-top 20rpx
        .dialog-info
            text-align center
            margin 10rpx 0
            color #3495FB
            p
                line-height 50rpx
                &:first-child
                    font-size 40rpx
    .clock-con
        height 100%
        .header
            flex 1
            height 70rpx
            padding 15rpx
            border-bottom 1px solid #F0F0F0
            display flex
            justify-content space-between
            .head-icon
                width 40rpx
                height 40rpx
                border-radius 50%
                background-color #3495FB
                display inline-block
                text-align center
                line-height 40rpx
                color #fff
                flex none
            .name
                flex 0 0 50%
                h4
                    font-size 16rpx
                div
                    font-size 14rpx
                    color #979EA7
            .time
                flex none
                font-size 14rpx
                color #979EA7
                line-height 32rpx
                .iconfont
                    font-size 14rpx
                    margin-left 5rpx
        .body
            flex 1
            height calc(100% - 120rpx)
            .tit-con
                height 30rpx
                background #F0F0F0
                display flex
                justify-content space-between
                padding 0 15rpx
                line-height 30rpx
                font-size 12rpx
                .icondaqiayueli
                    font-size 12rpx
                    margin-right 5rpx
                .left
                    color #979EA7
                .right
                    color #3495FB
            .time-days
                li
                    display flex
                    justify-content space-between
                    padding 0 10rpx
                    line-height 40rpx
                    font-size 16rpx
                    border-bottom 1px solid #ebedf0
                    .iconfont
                        font-size 14rpx
                        margin-left 5rpx
                    .days
                        color #979EA7
                    &:last-child
                        border-bottom none
            .split
                height 15rpx
                background #F0F0F0
            .van-collapse-item__content
                padding 0
                .times
                    li
                        display flex
                        justify-content space-between
                        font-size 14rpx
                        border-bottom 1px solid #ebedf0
                        padding 8rpx 15rpx
                        &:last-child
                            border-bottom none
                        .color1
                            color #333
                        .weekday
                            margin-left 10rpx

        .footer
            flex 1
            height 50rpx
            border-top 1px solid #F0F0F0
</style>
<style>
.timeKeeping-box .van-cell:not(:last-child)::after{
    left: 0;
}
.timeKeeping-box .van-cell{
    font-size: 16rpx;
}
</style>